module.exports = __webpack_public_path__ + "img/banestes.b4bf3c5d.svg";